import { GraduationCap, Instagram, Linkedin, Mail, Youtube } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../context/LanguageContext'

const socials = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/gurkankavrazli/', icon: Linkedin },
  { label: 'Instagram', href: 'https://www.instagram.com/gurkankavrazli/', icon: Instagram },
  { label: 'YouTube', href: 'https://www.youtube.com/@gurkankavrazl5470', icon: Youtube },
  {
    label: 'Superprof',
    href: 'https://www.superprof.com.tr/lojistik-bolumlerinde-okuyan-ogrenciler-yeni-mezunlar-sektorde-calisanlar-isverenler-firmalar-iyi-depo.html',
    icon: GraduationCap,
  },
  { label: 'E-posta', href: 'mailto:gurkankavrazli@gmail.com', icon: Mail },
]

export function Footer() {
  const { content, language } = useLanguage()
  const year = new Date().getFullYear()

  const links = [
    ['about', '/hakkimda'],
    ['services', '/hizmetler'],
    ['analyses', '/analizler'],
    ['research', '/arastirmalar'],
    ['media', '/medya'],
    ['lifestyle', '/yasam-stili'],
    ['blog', '/blog'],
    ['references', '/referanslar'],
    ['contact', '/iletisim'],
  ]

  return (
    <footer className="relative overflow-hidden bg-brand-navy text-white">
      <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full border border-white/10" />
      <div className="absolute -bottom-36 left-1/4 h-96 w-96 rounded-full bg-brand-orange/10 blur-3xl" />
      <div className="site-container relative py-5">
        <div className="grid gap-4 lg:grid-cols-[1.1fr_.9fr]">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/images/icongk.jpeg"
                alt="Gürkan Kavrazlı logosu"
                width="44"
                height="44"
                loading="lazy"
                className="h-11 w-11 shrink-0 rounded-lg border border-white/15 bg-white object-contain p-1 shadow-lg"
              />
              <div>
                <strong className="font-display text-lg">Gürkan Kavrazlı</strong>
                <p lang={language} className="text-xs font-semibold uppercase tracking-[0.16em] text-white/55">
                  {language === 'tr' ? 'Uluslararası Lojistik Stratejisti' : 'International Logistics Strategist'}
                </p>
              </div>
            </div>
            <p className="mt-3 max-w-xl text-sm leading-5 text-white/72">{content.footer.statement}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {socials.map(({ label, href, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith('http') ? '_blank' : undefined}
                  rel={href.startsWith('http') ? 'noreferrer' : undefined}
                  className="grid h-10 min-h-10 w-10 place-items-center rounded-full border border-white/15 text-white/75 transition-colors hover:border-brand-orange hover:bg-brand-orange hover:text-white"
                  aria-label={label}
                >
                  <Icon size={18} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-6 gap-y-1 sm:grid-cols-3">
            {links.map(([key, to]) => (
              <Link key={key} to={to} className="flex min-h-9 items-center text-sm font-semibold text-white/68 transition-colors hover:text-brand-orange">
                {content.nav[key]}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2 border-t border-white/10 pt-3 text-xs text-white/48 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} Gürkan Kavrazlı. {content.footer.rights}</p>
          <Link to="/admin/login" className="min-h-0 text-white/35 transition-colors hover:text-white/70">
            {content.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  )
}
